import BaseRequest from "@/utils/http/index";

let request = new BaseRequest('');
let prefix = '/api/patent';
let bsPreFix = '/bsapi';

export const findByUserId = (params) => {
  return request.post(prefix + '/contact/findByUserId',params)
}
// 查询 站内信数量
export const getInnerMsgCount = (params) => {
  return request.post(bsPreFix + '/common/getInnerMsgCount',params)
}
// 查询维护状态
export const querySourceMaintain = params => {
  return request.post('/api/source/release/querySourceMaintain',params)
}

// 查询 经纪人类型 内部或外部
export const getAgentTypeById = (params) => {
  // 1 -- 内部合伙  2 -- 外部合伙   3 -- 机构合伙
  return request.post(prefix + '/agent/getAgentType',params)
};

// 查询用户身份信息
export const synchronizeUser = (params) => {
  return request.post(prefix + '/user/synchronizeUser',params)
};

// 查询用户的角色权限
export const getRoleMenu = (params) => {
  return request.post('/api/source/role/getRoleMenuNew',params)
};

// 获取灰度账号
export const queryConstantOptimizeInfo = (params) => {
  return request.post(bsPreFix + '/legend4/common/queryConstantOptimizeInfo', params);
};

// 根据条件获取用户信息
export const queryUserInfo = (params) => {
  return request.post(prefix + '/user/queryUserInfo',params)
};